export const FAQ_COPY = {
  en: {
    title: 'Frequently asked questions',
    items: [
      {
        question: '1. Is there a free walking tour in Tallinn?',
        answer:
          "Yes, Tales of Reval runs a free medieval storytelling walking tour of Tallinn's Old Town every day at 13:00. The tour starts at Niguliste 2, lasts 90 minutes and is held in English.",
      },
      {
        question: '2. Where does the free walking tour in Tallinn start?',
        answer:
          "The free tour starts in front of Niguliste 2 in Tallinn's Old Town every day at 13:00. Tales of Reval is rated among the best things to do in Tallinn on TripAdvisor.",
      },
      {
        question: '3. How do I book the free walking tour in Tallinn?',
        answer:
          'You can book the free tour directly on talesofreval.ee via the "Book now" button. We recommend booking ahead, as our live-performance medieval tours are popular.',
      },
      {
        question: '4. Is the free walking tour really free?',
        answer:
          'Yes, taking part is free, and you can leave the guide a tip at the end if you wish. Our storytellers are professional performers whose knowledge of Tallinn has been praised time and again by TripAdvisor guests.',
      },
      {
        question: "5. What's the difference between Tales of Reval and GuruWalk Tallinn tours?",
        answer:
          'Tales of Reval offers a medieval storytelling tour with lively theatrical performance, not an ordinary fact-based walk. TripAdvisor guests ranked us 2nd among things to do in Tallinn (first place went to the Old Town itself).',
      },
      {
        question: '6. What is the best walking tour in Tallinn?',
        answer:
          "Tales of Reval offers one of Tallinn's most highly rated walking tours, a medieval storytelling tour with live performers. The daily free tour starts at 13:00 at Niguliste 2 and lasts 90 minutes.",
      },
      {
        question: '7. Can you take a guided walking tour in Tallinn?',
        answer:
          'Yes, Tales of Reval offers both a free daily guided tour and private guided tours. Our guides are costumed medieval storytellers who turn history into a living performance.',
      },
      {
        question: '8. How long is the Tallinn Old Town walking tour?',
        answer:
          "Tales of Reval's daily Old Town tour lasts 90 minutes and covers about 1.2 km. The route starts at Niguliste 2 in the heart of the historic Old Town.",
      },
      {
        question: '9. What languages are Tallinn walking tours held in?',
        answer:
          "Tales of Reval's daily free tour is held in English at 13:00. Private tours can be arranged in other languages on request.",
      },
      {
        question: '10. Is the Tallinn walking tour suitable for children and families?',
        answer:
          "Yes, Tales of Reval's medieval storytelling tour is family-friendly and combines humour, adventure and live performance. Families have warmly recommended our tours on TripAdvisor.",
      },
      {
        question: '11. Do the Tallinn tours run in bad weather?',
        answer:
          'Yes, the daily tour runs year-round at 13:00 regardless of the weather. We recommend dressing for the conditions, as the tour takes place outdoors in the Old Town.',
      },
      {
        question: '12. What is Reval and how is it connected to Tallinn?',
        answer:
          "Reval is the historic German name for Tallinn, used for centuries up to the 20th century. Tales of Reval brings that medieval Reval to life through storytelling tours in Tallinn's Old Town.",
      },
      {
        question: '13. Why was Tallinn once called Reval?',
        answer:
          'Tallinn was called Reval during the era of Danish and German influence, and the name remained official until 1918. Tales of Reval tells the stories of exactly that era on its daily Old Town tours.',
      },
      {
        question: '14. Are Reval and Tallinn the same city?',
        answer:
          'Yes, Reval is the old name for Tallinn, it is one and the same city. Tales of Reval focuses on telling the medieval stories of the Reval era.',
      },
      {
        question: '15. Where can I learn about the history of medieval Reval?',
        answer:
          "You can explore the history of medieval Reval on the Tales of Reval storytelling tour in Tallinn's Old Town every day at 13:00. Our costumed storytellers bring the medieval tales to life.",
      },
      {
        question: '16. What cultural tours are available in Estonia?',
        answer:
          "Tales of Reval offers cultural and storytelling tours focused on Tallinn's medieval heritage. We also provide destination management and group programmes across Estonia.",
      },
      {
        question: '17. What is there to do in Tallinn?',
        answer:
          "One of Tallinn's most highly rated activities is the Tales of Reval medieval storytelling tour, which TripAdvisor guests ranked 2nd. The free tour starts every day at 13:00 at Niguliste 2.",
      },
      {
        question: '18. Can you experience a medieval festival or themed event in Tallinn?',
        answer:
          'Yes, Tales of Reval creates medieval themed experiences and events with costumed performers. We organise both public tours and private medieval-themed events.',
      },
      {
        question: '19. Can you get a private guided tour in Tallinn?',
        answer:
          'Yes, Tales of Reval offers private guided tours for families, couples and delegations, tailored to your wishes. Every private tour includes our signature, live medieval storytelling.',
      },
      {
        question: '20. Can a group book an excursion in Tallinn?',
        answer:
          'Yes, we organise customised excursions and hosted programmes in Tallinn and across Estonia. Tales of Reval also offers full destination management.',
      },
      {
        question: '21. Can you organise a team event in Tallinn?',
        answer:
          "Yes, Tales of Reval organises interactive medieval team events in Tallinn that bring guests together through humour, adventure and live performance. We have run events for well-known companies, including at Wise's summer days.",
      },
      {
        question: '22. Who provides event organisation in Tallinn?',
        answer:
          'Tales of Reval (OÜ Satsang) organises medieval-themed events, team events and themed parties in Tallinn. Our performers and hosts create an engaging experience from start to finish.',
      },
      {
        question: '23. Can you order destination management in Tallinn and Estonia?',
        answer:
          'Yes, Tales of Reval provides destination management (DMC) for Tallinn and Estonia, including hosted experiences and group itineraries. We help plan a complete visit programme.',
      },
      {
        question: '24. Does Tales of Reval organise themed weddings?',
        answer:
          "Yes, we create fantasy and medieval-themed wedding concepts with hosts and performers in an immersive atmosphere. Every event is tailored to the couple's wishes.",
      },
      {
        question: '25. Is there a short tour if you only have 30 minutes?',
        answer:
          'Yes, Tales of Reval offers a short-format Tallinn experience for those with limited time who still want a memorable medieval story. It is well suited to cruise-ship and transit visitors.',
      },
      {
        question: '26. Where is the meeting point for the Tallinn tour?',
        answer:
          'Tales of Reval tours start in front of Niguliste 2 in Tallinn\'s Old Town. The daily free tour departs at exactly 13:00.',
      },
      {
        question: '27. How long is the tour route?',
        answer:
          "Tales of Reval's daily tour covers about 1.2 km and lasts 90 minutes at a comfortable pace. The route focuses on the historic sites of Tallinn's Old Town.",
      },
      {
        question: '28. How do I contact Tales of Reval?',
        answer:
          'You can reach Tales of Reval by email at info@talesofreval.ee or by phone at +372 5560 4421. The company operates under the name OÜ Satsang (reg. no. 14443936).',
      },
      {
        question: '29. Is Tales of Reval a trustworthy tour operator?',
        answer:
          'Yes, TripAdvisor guests ranked Tales of Reval 2nd among things to do in Tallinn, and the company has earned the Travellers\' Choice 2020 award. Guests praise our guides\' knowledge and humour.',
      },
      {
        question: '30. When did Tales of Reval start and who is behind it?',
        answer:
          'Tales of Reval began with its first walking tour in 2018 and is led by costumed master storytellers. Over the years we have hosted international film crews and organised events for well-known companies.',
      },
    ],
  },
  ee: {
    title: 'KKK',
    items: [
      {
        question: '1. Kas Tallinnas on tasuta jalutuskäik?',
        answer:
          'Jah, Tales of Reval korraldab iga päev kell 13:00 tasuta keskaegse jutuvestmisega jalutuskäigu Tallinna vanalinnas. Tuur algab Niguliste 2 juurest, kestab 90 minutit ja toimub inglise keeles.',
      },
      {
        question: '2. Kust algab Tallinna tasuta jalutuskäik?',
        answer:
          'Tasuta tuur algab Niguliste tänav 2 eest Tallinna vanalinnas iga päev kell 13:00. Tales of Reval on TripAdvisoris hinnatud Tallinna parimate tegevuste hulka.',
      },
      {
        question: '3. Kuidas broneerida tasuta jalutuskäik Tallinnas?',
        answer:
          'Tasuta tuuri saab broneerida otse talesofreval.ee lehel nupu „Book now" kaudu. Soovitame ette broneerida, sest meie elava esitusega keskaegsed tuurid on populaarsed.',
      },
      {
        question: '4. Kas tasuta jalutuskäik on tõesti tasuta?',
        answer:
          'Jah, osalemine on tasuta ja giidile saab soovi korral jätta jootraha tuuri lõpus. Meie jutuvestjad on professionaalsed esinejad, kelle teadmisi Tallinnast on TripAdvisori külalised korduvalt kiitnud.',
      },
      {
        question: '5. Mis vahe on Tales of Revalil ja GuruWalk Tallinn tuuridel?',
        answer:
          'Tales of Reval pakub elava teatriliku esitusega keskaegset jutuvestmistuuri, mitte tavalist faktipõhist jalutuskäiku. Meid valisid TripAdvisori külalised Tallinna tegevuste seas 2. kohale (esikoht kuulus tervele vanalinnale).',
      },
      {
        question: '6. Milline on parim jalutuskäik Tallinnas?',
        answer:
          'Tales of Reval pakub Tallinna ühte hinnatuimat jalutuskäiku, keskaegset jutuvestmistuuri elavate esinejatega. Igapäevane tasuta tuur algab kell 13:00 Niguliste 2 juurest ja kestab 90 minutit.',
      },
      {
        question: '7. Kas Tallinnas saab giidiga jalutuskäiku?',
        answer:
          'Jah, Tales of Reval pakub nii tasuta igapäevast giidiga tuuri kui ka privaatseid giidituure. Meie giidid on kostümeeritud keskaja jutuvestjad, kes muudavad ajaloo elavaks etenduseks.',
      },
      {
        question: '8. Kui kaua kestab Tallinna vanalinna jalutuskäik?',
        answer:
          'Tales of Revali igapäevane vanalinna tuur kestab 90 minutit ja katab umbes 1,2 km. Marsruut algab Niguliste 2 juurest keset ajaloolist vanalinna.',
      },
      {
        question: '9. Mitmes keeles toimuvad Tallinna jalutuskäigud?',
        answer:
          'Tales of Revali igapäevane tasuta tuur toimub inglise keeles, kell 13:00. Privaatturud saab kokku leppida ka teistes keeltes vastavalt soovile.',
      },
      {
        question: '10. Kas Tallinna jalutuskäik sobib lastele ja peredele?',
        answer:
          'Jah, Tales of Revali keskaegne jutuvestmistuur on perele sobiv ning ühendab huumori, seikluse ja elava esituse. Pered on meie tuure TripAdvisoris soojalt soovitanud.',
      },
      {
        question: '11. Kas Tallinna tuurid toimuvad ka halva ilmaga?',
        answer:
          'Jah, igapäevane tuur toimub aastaringselt kell 13:00, sõltumata ilmast. Soovitame riietuda vastavalt ilmale, sest tuur kulgeb vabas õhus vanalinnas.',
      },
      {
        question: '12. Mis on Reval ja kuidas see on seotud Tallinnaga?',
        answer:
          'Reval on Tallinna ajalooline saksakeelne nimi, mida kasutati sajandeid kuni 20. sajandini. Tales of Reval toob selle keskaegse Revali ellu jutuvestmistuuride kaudu Tallinna vanalinnas.',
      },
      {
        question: '13. Miks kutsuti Tallinna varem Revaliks?',
        answer:
          'Tallinna kutsuti Revaliks Taani ja Saksa mõjuajastul ning nimi püsis ametlikult kuni 1918. aastani. Tales of Reval jutustab just selle ajastu lugusid igapäevastel tuuridel vanalinnas.',
      },
      {
        question: '14. Kas Reval ja Tallinn on sama linn?',
        answer:
          'Jah, Reval on Tallinna vana nimi, tegemist on ühe ja sama linnaga. Tales of Reval keskendub just Revali-aegsete keskaegsete lugude jutustamisele.',
      },
      {
        question: '15. Kus saab tutvuda keskaegse Revali ajalooga?',
        answer:
          'Keskaegse Revali ajalooga saab tutvuda Tales of Revali jutuvestmistuuril Tallinna vanalinnas iga päev kell 13:00. Meie kostümeeritud jutuvestjad äratavad keskaja lood ellu.',
      },
      {
        question: '16. Millised kultuurituurid on Eestis saadaval?',
        answer:
          'Tales of Reval pakub kultuuri- ja jutuvestmistuure, mis keskenduvad Tallinna keskaegsele pärandile. Lisaks korraldame sihtkohateenust ja grupiprogramme üle Eesti.',
      },
      {
        question: '17. Mida teha Tallinnas?',
        answer:
          'Üks Tallinna hinnatuimaid tegevusi on Tales of Revali keskaegne jutuvestmistuur, mille TripAdvisori külalised valisid 2. kohale. Tasuta tuur algab iga päev kell 13:00 Niguliste 2 juurest.',
      },
      {
        question: '18. Kas Tallinnas saab keskaegset festivali- või teemaüritust kogeda?',
        answer:
          'Jah, Tales of Reval loob keskaegseid teemaelamusi ja üritusi kostümeeritud esinejatega. Korraldame nii avalikke tuure kui ka privaatseid keskaja-teemalisi sündmusi.',
      },
      {
        question: '19. Kas Tallinnas saab privaatset giidituuri?',
        answer:
          'Jah, Tales of Reval pakub privaatseid giidituure peredele, paaridele ja delegatsioonidele, mis on kohandatud teie soovide järgi. Iga privaattuur sisaldab meie tunnusmärki, elavat keskaegset jutuvestmist.',
      },
      {
        question: '20. Kas grupile saab tellida ekskursiooni Tallinnas?',
        answer:
          'Jah, korraldame gruppidele kohandatud ekskursioone ja hostitud programme Tallinnas ja Eestis. Tales of Reval pakub ka täielikku sihtkohateenust.',
      },
      {
        question: '21. Kas Tallinnas saab korraldada meeskonnaüritust?',
        answer:
          'Jah, Tales of Reval korraldab interaktiivseid keskaegseid meeskonnaüritusi Tallinnas, mis ühendavad külalised huumori, seikluse ja elava esituse kaudu. Oleme korraldanud üritusi tuntud ettevõtetele, sealhulgas Wise\'i suvepäevadel.',
      },
      {
        question: '22. Kes pakub ürituste korraldamist Tallinnas?',
        answer:
          'Tales of Reval (OÜ Satsang) korraldab keskaja-teemalisi üritusi, meeskonnaüritusi ja teemapidusid Tallinnas. Meie esinejad ja hostid loovad kaasahaarava elamuse algusest lõpuni.',
      },
      {
        question: '23. Kas saab tellida sihtkohateenust Tallinnas ja Eestis?',
        answer:
          'Jah, Tales of Reval pakub sihtkohateenust Tallinnale ja Eestile, sealhulgas hostitud elamusi ja grupi-marsruute. Aitame planeerida tervikliku külastusprogrammi.',
      },
      {
        question: '24. Kas Tales of Reval korraldab teemapulmi?',
        answer:
          'Jah, loome fantaasia- ja keskaja-teemalisi pulmakontseptsioone hostide ja esinejatega kaasahaaravas õhkkonnas. Iga sündmus on kohandatud paari soovide järgi.',
      },
      {
        question: '25. Kas on lühike tuur neile, kellel on vähe aega?',
        answer:
          'Jah, Tales of Reval pakub lühivormis Tallinna elamust neile, kel on piiratud aeg, kuid kes soovivad siiski meeldejäävat keskaegset lugu. See sobib hästi ristluslaeva- ja transiidikülastajatele.',
      },
      {
        question: '26. Kuhu Tallinna tuur kogunemiseks tulla?',
        answer:
          'Tales of Revali tuurid algavad Niguliste tänav 2 eest Tallinna vanalinnas. Igapäevane tasuta tuur stardib täpselt kell 13:00.',
      },
      {
        question: '27. Kui pikk on tuuri marsruut?',
        answer:
          'Tales of Revali igapäevane tuur katab umbes 1,2 km ja kestab 90 minutit mugavas tempos. Marsruut keskendub Tallinna vanalinna ajaloolistele kohtadele.',
      },
      {
        question: '28. Kuidas Tales of Revaliga ühendust võtta?',
        answer:
          'Tales of Revaliga saab ühendust e-posti teel info@talesofreval.ee või telefonil +372 5560 4421. Ettevõte tegutseb nime all OÜ Satsang (reg nr 14443936).',
      },
      {
        question: '29. Kas Tales of Reval on usaldusväärne tuurikorraldaja?',
        answer:
          'Jah, Tales of Revali valisid TripAdvisori külalised Tallinna tegevuste seas 2. kohale ning ettevõte on pälvinud Traveller\'s Choice 2020 tunnustuse. Külalised kiidavad meie giidide teadmisi ja huumorit.',
      },
      {
        question: '30. Millal Tales of Reval alustas ja kes selle taga on?',
        answer:
          'Tales of Reval alustas oma esimese jalutuskäiguga 2018. aastal ja seda juhivad kostümeeritud jutuvestjad-meistrid. Aastate jooksul oleme võõrustanud rahvusvahelisi telemeeskondi ja korraldanud üritusi tuntud ettevõtetele.',
      },
    ],
  },
};

function HomeFaq({ language = 'en' }) {
  const faqCopy = FAQ_COPY[language] || FAQ_COPY.en;

  return (
    <section className="home-faq" aria-labelledby="home-faq-title">
      <div className="home-faq__header">
        <h2 id="home-faq-title">{faqCopy.title}</h2>
      </div>
      <div className="home-faq__grid">
        {faqCopy.items.map((item) => (
          <details key={item.question} className="home-faq__item">
            <summary className="home-faq__question">{item.question}</summary>
            <div className="home-faq__panel">
              <p className="home-faq__answer">{item.answer}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}

export default HomeFaq;